import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import $ from "jquery";
import { minDate } from "../../Constants/Constants";

const UpdateOfficeUtils = ({
  getData,
  selectedRowsData,
  updateHandleChange,
  setselectedRowsData,
  setSelectedCompanyId,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const companyName = selectedRowsData.company?.company_name || "";
  const staffName = selectedRowsData.staff_name?.staff_name || "";
  const Number = selectedRowsData.staff_name?.mob_num || "";
  const selectedCompanyId = selectedRowsData.company?.id || "";
  const staffId = selectedRowsData.staff_name?.id || "";

  const [staff, setStaff] = useState([]);
  const [personName, setPersonName] = useState("");
  const [mobNumber, setMobNumber] = useState("");
  const [company, setCompany] = useState([]);
  const [companyId, setCompanyId] = useState("");

  const closeModal = () => {
    $(".custom-close-button-color").trigger("click");
  };

  function resetFildes() {
    setselectedRowsData({
      staff_id: "",
      company_id: "",
      received_date: "",
      pc_name: "",
      printer_name: "",
      specification: "",
      warrenty_guarantee: "",
      status_remark: "",
      mob_num: "",
    });
    setSelectedCompanyId("");
    setMobNumber("");
  }

  const getStaff = async () => {
    const BASE_URL =
      SERVER_URL +
      `/api/staff-detials/drop-staffDetails/${user_id}?company_id=${companyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setStaff(result.data);
  };

  useEffect(() => {
    if (companyId) {
      getStaff();
    }
  }, [companyId]);

  const handleCompanyChange = (e) => {
    const value = e.target.value;
    setCompanyId(value ? value : "");
    setStaff([]);
    setPersonName("");
    setMobNumber("");
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const {
      id,
      received_date,
      pc_name,
      printer_name,
      specification,
      warrenty_guarantee,
      status_remark,
      mob_num,
    } = selectedRowsData;
    const from_date = moment.utc(received_date, "YYYY-MM-DD").toISOString();
    let BASE_URL =
      SERVER_URL + `/api/officeUtils/officeUtils-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        staff_id: staffId,
        company_id: selectedCompanyId,
        received_date: from_date,
        pc_name,
        printer_name,
        specification,
        warrenty_guarantee,
        status_remark,
        mob_num,
      }),
    });

    const response = await res.json();

    if (res.ok) {
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const handleOfficeUtils = (e) => {
    const selectedStaffId = e.target.value;
    const selectedStaff = staff.find(
      (item) => item.id.toString() === selectedStaffId
    );
    if (selectedStaff) {
      setPersonName(selectedStaff.id);
      setMobNumber(selectedStaff.mob_num);
    } else {
      setPersonName("");
      setMobNumber("");
    }
  };

  useEffect(() => {
    if (selectedRowsData) {
      setCompanyId(selectedRowsData?.company_id);
      setPersonName(selectedRowsData?.staff_id);
    }
  }, [selectedRowsData]);

  useEffect(() => {
    if (mobNumber) {
      setselectedRowsData((prevData) => ({ ...prevData, mob_num: mobNumber }));
    }
  }, [mobNumber]);
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateOfficeModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Office Equipment
              </h5>
              <button
                type="button"
                className="custom-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFildes}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Update Office Equipment</h4> */}
                    <form className="form-sample" onSubmit={handleUpdate}>
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="received_date">Received Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="received_date"
                              id="received_date"
                              placeholder="Enter Received Date"
                              onChange={updateHandleChange}
                              value={selectedRowsData.received_date}
                              required
                              autoComplete="off"
                              // min={minDate}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="pc_name">PC Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="pc_name"
                              id="pc_name"
                              placeholder="Enter PC Name"
                              onChange={updateHandleChange}
                              value={selectedRowsData.pc_name}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="printer_name">Printer</label>
                            <input
                              type="text"
                              className="form-control"
                              name="printer_name"
                              id="printer_name"
                              placeholder="Enter Printer Name"
                              onChange={updateHandleChange}
                              value={selectedRowsData.printer_name}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="company_id">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleCompanyChange}
                              value={companyId}
                              required
                              id="company_id"
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company.length > 0 &&
                                company.map((item, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={item.id}
                                    >{`${item.company_name},${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Person">Person</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleOfficeUtils}
                              value={personName}
                              required
                              id="Person"
                            >
                              <option value="">Select Person</option>
                              {staff &&
                                staff.length > 0 &&
                                staff.map((item, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={item.id}
                                    >{`${item.staff_name}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="mob">Mob. Number</label>
                            <input
                              id="mob"
                              type="text"
                              className="form-control"
                              name="mob_num"
                              value={selectedRowsData?.mob_num}
                              placeholder="Mob. Number"
                              onChange={updateHandleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="specification">Specification</label>
                            <input
                              type="text"
                              className="form-control"
                              name="specification"
                              id="specification"
                              placeholder="Enter Specification"
                              onChange={updateHandleChange}
                              value={selectedRowsData.specification}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="warrenty_guarantee">
                              Warrenty Guarrenty
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="warrenty_guarantee"
                              id="warrenty_guarantee"
                              placeholder="Enter Warrenty Guarrenty"
                              onChange={updateHandleChange}
                              value={selectedRowsData.warrenty_guarantee}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="status_remark">Status Remark</label>
                            <input
                              type="text"
                              className="form-control"
                              name="status_remark"
                              id="status_remark"
                              placeholder="Enter Status Remark"
                              onChange={updateHandleChange}
                              value={selectedRowsData.status_remark}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>

                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleUpdate}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateOfficeUtils;
